// Vendors
import React, { useEffect, useState } from 'react';
import axios from 'axios';

// Components
import { NestedCheckboxes } from '../../components';

const BulkMessage = ({ projects, adminFilters: { status }, setMainNotice }) => {
  const [bulkMessage, setBulkMessage] = useState('');
  const [selectedProjectIDs, setSelectedProjectIDs] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [justSentMessage, setJustSentMessage] = useState(false);

  const handleSelectProject = (pid) => {
    if (!pid) return;

    let newArr = [...selectedProjectIDs];

    // if id is already present in array, remove from array.
    if (newArr.includes(pid)) {
      newArr = selectedProjectIDs.filter((id) => id !== pid);
    } else {
      // else add.
      newArr.push(pid);
    }

    setSelectedProjectIDs(newArr);
  };

  const handleSelectMultipleProjects = (pids) => {
    if (!pids.length) return;

    let newArr = [...selectedProjectIDs];

    const allProjectIDsPresent =
      newArr.length > 0 && pids.every((pid) => newArr.includes(pid));

    // If all Project IDs are present, bulk remove all of them.
    if (allProjectIDsPresent) {
      pids.map((pid) => (newArr = newArr.filter((id) => id !== pid)));
    } else {
      // Not all are present, check if SOME are present, if so, add rest.
      pids.map((pid) => {
        if (!newArr.includes(pid)) {
          newArr.push(pid);
        }
      });
    }

    setSelectedProjectIDs(newArr);
  };

  const handleToggleAllCheckboxes = () => {
    const allProjectIDs = Object.values(filteredProjects)
      .map((projects) => projects.map((project) => project.pid))
      .flat();

    if (selectedProjectIDs.length === projects.length) {
      setSelectedProjectIDs([]);
    } else {
      setSelectedProjectIDs([...allProjectIDs]);
    }
  };

  const handleSendMessage = () => {
    if (!selectedProjectIDs.length) return;

    setLoading(true);

    const formData = new FormData();
    formData.append('action', 'wl_pip_post_bulk_project_message');
    formData.append('message', bulkMessage);
    formData.append('pids', selectedProjectIDs);

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(({ data: { success, data } }) => {
        setLoading(false);

        if (success) {
          setJustSentMessage(true);
        }

        setMainNotice({
          type: success ? 'success' : 'error',
          message: data.message
        });
      })
      .catch((error) => {
        setMainNotice({
          type: 'error',
          message: error
        });

        setLoading(false);
      });
  };

  useEffect(() => {
    let projectsGroupedByBuilder = {};

    // Sort json by builder's last name.
    const filteredProjects = projects.sort((a, b) => {
      const x = a.builder.last_name;
      const y = b.builder.last_name;
      return x < y ? -1 : x > y ? 1 : 0;
    });

    // Format data for checkboxes div.
    filteredProjects.map((project) => {
      const { last_name, first_name, user_email, ID } = project.builder;
      const propertyName =
        last_name && first_name
          ? `${last_name}, ${first_name} (${user_email})`
          : `${ID} ${user_email}`;

      if (projectsGroupedByBuilder.hasOwnProperty(propertyName)) {
        projectsGroupedByBuilder[propertyName].push(project);
      } else {
        projectsGroupedByBuilder[propertyName] = [project];
      }
    });

    setFilteredProjects({ ...projectsGroupedByBuilder });
  }, [projects]);

  return (
    <>
      <div className="grid__col-xs-12 u--padding-top-0 u--padding-bottom-0">
        <hr className="u--margin-top-0 u--margin-bottom-20" />
        <label
          className={`form__checkbox form__checkbox--sm u--margin-top-0 u--margin-bottom-10 ${
            selectedProjectIDs.length === projects.length &&
            selectedProjectIDs.length === 0
              ? 'form__checkbox--disabled'
              : ''
          }`}
        >
          <input
            type="checkbox"
            checked={
              selectedProjectIDs.length === projects.length &&
              selectedProjectIDs.length !== 0
            }
            onChange={() => handleToggleAllCheckboxes()}
          />{' '}
          {selectedProjectIDs.length === projects.length &&
          selectedProjectIDs.length !== 0
            ? 'Deselect'
            : 'Select'}{' '}
          <em className="u--margin-left-5 u--margin-right-5">all</em> {status}{' '}
          projects.
        </label>
      </div>
      <div className="grid__col-xs-12 grid__col-md-6 u--padding-top-0">
        <div className="nested-checkboxes-wrapper">
          {Object.keys(filteredProjects).length === 0
            ? `No ${status} projects.`
            : Object.entries(filteredProjects).map((entries, index) => (
                <NestedCheckboxes
                  key={index}
                  data={entries}
                  selectedProjectIDs={selectedProjectIDs}
                  handleSelectProject={handleSelectProject}
                  handleSelectMultipleProjects={handleSelectMultipleProjects}
                />
              ))}
        </div>
      </div>
      <div className="grid__col-xs-12 grid__col-md-6 u--padding-top-0">
        <div className="form__field u--margin-bottom-20">
          <textarea
            type="textarea"
            className="form__textarea form__textarea--sm"
            style={{ height: '200px' }}
            placeholder={
              selectedProjectIDs.length === 0
                ? `(Select ${status} projects to send message to.)`
                : `(Send project message to${
                    selectedProjectIDs.length >= 1
                      ? ` ${selectedProjectIDs.length}`
                      : ''
                  } ${status} ${
                    selectedProjectIDs.length === 1 ? 'project' : 'projects'
                  }.)`
            }
            value={bulkMessage}
            onChange={(event) => {
              if (justSentMessage) setJustSentMessage(false);
              setBulkMessage(event.target.value);
            }}
            disabled={loading}
          />
        </div>
        {selectedProjectIDs.length === projects.length &&
          selectedProjectIDs.length !== 0 && (
            <span className="u--display-block u--color-red u--margin-bottom-20">
              You will be sending a message to{' '}
              <strong>all {selectedProjectIDs.length}</strong> {status}{' '}
              projects.
            </span>
          )}
        <button
          className={`btn btn--xs btn--green ${
            loading === true ? 'btn--loading' : ''
          }`}
          type="button"
          onClick={() => handleSendMessage()}
          disabled={
            selectedProjectIDs.length === 0 ||
            loading === true ||
            justSentMessage == true
          }
        >
          <span className="btn__content">
            <span className="btn__text">Send Project Message</span>
          </span>
        </button>
      </div>
      <div className="grid__col-xs-12 u--padding-top-0 u--padding-bottom-0">
        <hr className="u--margin-0" />
      </div>
    </>
  );
};

export default BulkMessage;
